<div class="dialog-box">
    <div class="g-header-row">
        <div class="g-left-section">
            <p class="g-header">Add Transporters</p>
        </div>
        <div class="g-right-section">
            <img src="../../../assets/icons/close-x.svg" (click)="closeDialog()">
        </div>
    </div>
    <div class="view-container">
        <!-- All Transporters -->
        <div class="container-column">
            <p class="header">All Transporters ({{ allTransporters.length }})</p>
            <input type="text" [(ngModel)]="searchAll" placeholder="Search" class="search-box" />
            <div class="list-column">
                <div *ngFor="let transporter of filteredAllTransporters">
                    <mat-checkbox [(ngModel)]="transporter.isSelected" [disabled]="transporter.isDisabled ?? false">{{ transporter.name }}</mat-checkbox>
                </div>
            </div>
        </div>
    
        <!-- Action Buttons -->
        <div class="shorting-buttons">
            <img src="../../../assets/icons/arrow-right.svg" (click)="moveToShortlist()">
            <img src="../../../assets/icons/arrow-left.svg" (click)="moveToAll()">
        </div>
    
        <!-- Shortlisted Transporters -->
        <div class="container-column">
            <p class="header">Shortlisted Transporters ({{ shortlistedTransporters.length }})</p>
            <input type="text" [(ngModel)]="searchShortlisted" placeholder="Search" class="search-box" />
            <div class="list-column">
                <div *ngFor="let transporter of filteredShortlistedTransporters">
                    <mat-checkbox [(ngModel)]="transporter.isSelected" >{{ transporter.name }}</mat-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div class="actions">
        <button class="btn secondary medium" (click)="closeDialog()">Cancel </button>
        <button class="btn primary medium" (click)="closeDialogWithResult()">Save</button>
    </div>
</div>